export const dateTimeFormatter = new Intl.DateTimeFormat("fr", {
  day: "numeric",
  month: "short",
  year: "numeric",
});
export const shortDateFormatter = new Intl.DateTimeFormat("fr", {
  day: "2-digit",
  month: "2-digit",
  year: "2-digit",
  formatMatcher: "basic",
});
